import React, { useEffect, useState } from 'react';
import { Label } from '@/components/ui/label';
import { referralPortalApi } from '../api/referralPortal.api';

/** Campus doctors on duty today who can issue referral letters. */
export default function PreferredDoctorField({ value, onChange }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    referralPortalApi
      .providers()
      .then((data) => {
        if (alive) setItems(data?.items || []);
      })
      .catch(() => {
        if (alive) setItems([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="space-y-2">
      <Label htmlFor="preferred-doctor" className="text-sm font-semibold text-stone-800">
        Campus doctor for referral letter
      </Label>
      <p className="text-xs text-stone-500">
        Only medical officers on today’s published roster (or doctors marked “Can provide referral”).
      </p>
      <select
        id="preferred-doctor"
        required
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading || items.length === 0}
        className="h-11 w-full rounded-xl border border-stone-200 bg-white px-3 text-sm"
        data-testid="preferred-doctor-select"
      >
        <option value="">
          {loading
            ? 'Loading on-duty doctors…'
            : items.length
              ? 'Select on-duty doctor…'
              : 'No on-duty medical officers available today'}
        </option>
        {items.map((d) => (
          <option key={d.id} value={d.id}>
            {d.name}{d.specialization ? ` — ${d.specialization}` : ''}
            {d.clinic_role ? ` (${String(d.clinic_role).replace(/_/g, ' ')})` : ''}
          </option>
        ))}
      </select>
    </div>
  );
}
